'use client';

import React from 'react';
import { I18nProvider } from './I18nContext';

interface I18nClientProviderProps {
  children: React.ReactNode;
}

export function I18nClientProvider({ children }: I18nClientProviderProps) {
  return <I18nProvider>{children}</I18nProvider>;
}
